import { Eye, ArrowRight, X } from 'lucide-react'
import { useAuth_M1_2 } from '@/contexts/AuthProvider'
import { useState } from 'react'

export function PreviewBanner_M10_33() {
  const { isPreview, exitPreview } = useAuth_M1_2()
  const [minimized, setMinimized] = useState(false)

  if (!isPreview) return null

  if (minimized) {
    return (
      <button
        onClick={() => setMinimized(false)}
        className="fixed top-3 right-3 z-50 h-8 w-8 rounded-full bg-primary/90 text-white flex items-center justify-center shadow-glow-sm hover:bg-primary transition-colors"
        aria-label="Show preview banner"
      >
        <Eye className="h-3.5 w-3.5" />
      </button>
    )
  }

  return (
    <div className="sticky top-0 z-50 w-full">
      <div className="bg-gradient-to-r from-primary/90 to-primary/70 backdrop-blur-sm px-4 py-2">
        <div className="flex items-center justify-between max-w-5xl mx-auto">
          <div className="flex items-center gap-2 text-white/90 text-xs">
            <Eye className="h-3.5 w-3.5" />
            <span className="font-medium">Preview Mode</span>
            <span className="hidden sm:inline text-white/60">— Sign up to save your progress</span>
          </div>
          <div className="flex items-center gap-2">
            <button
              onClick={exitPreview}
              className="inline-flex items-center gap-1 rounded-full bg-white/20 hover:bg-white/30 px-3 py-1 text-[11px] font-medium text-white transition-colors"
            >
              Sign Up
              <ArrowRight className="h-3 w-3" />
            </button>
            <button
              onClick={() => setMinimized(true)}
              className="text-white/50 hover:text-white/80 transition-colors"
              aria-label="Minimize banner"
            >
              <X className="h-3.5 w-3.5" />
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
